<div class="default-exemption-form">
    <form [formGroup]="form" class="space-y-4">
        <!-- License Plates Regex -->
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>License Plate Regex Pattern</mat-label>
            <input matInput formControlName="licensePlatesRegex" placeholder="e.g., ^ABC.*">
            <mat-icon matSuffix class="text-gray-400">code</mat-icon>
            <mat-hint>Regular expression pattern to match license plates</mat-hint>
        </mat-form-field>

        <!-- Parking Zones Multi-Select -->
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Parking Zones</mat-label>
            <mat-select formControlName="availableForParkingZones" multiple>
                @for (zone of availableZones(); track zone.id) {
                <mat-option [value]="zone.id">{{ zone.name }}</mat-option>
                }
            </mat-select>
            <mat-hint>Optional: leave empty for the whole space</mat-hint>
        </mat-form-field>

        <!-- Availability Period -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available From</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="availableFrom">
                <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for immediate availability</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available To</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="availableTo">
                <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for no end date</mat-hint>
            </mat-form-field>
        </div>

        <!-- Do not record -->
        <div class="flex items-start justify-between gap-4 rounded-xl border border-slate-200 bg-slate-50 p-3">
            <div>
                <p class="text-sm font-medium text-slate-800">Do not record parking processes</p>
                <p class="text-xs text-slate-500 mt-0.5">The barrier still opens and the display still
                    shows a welcome, but these vehicles leave no parking process — so they stay out of
                    reports and occupancy figures. Use for police and emergency fleets.</p>
            </div>
            <mat-slide-toggle formControlName="skipProcessRecording" color="primary"></mat-slide-toggle>
        </div>

        <!-- Info Box -->
        <div class="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <div class="flex items-start gap-2">
                <mat-icon class="text-amber-600 text-sm">info</mat-icon>
                <div class="text-sm text-amber-800">
                    <p><strong>Default Exemption:</strong> Vehicles matching the regex pattern will be automatically
                        exempted from parking fees.</p>
                </div>
            </div>
        </div>
    </form>
</div>